import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { Input } from 'semantic-ui-react';

const CohortFieldInput = ({
  autoFocus,
  text,
  type,
  maxLength,
  icon,
  iconPosition,
  size,
  onChange,
  className,
}) => {
  const intl = useIntl();
  return (
    <Input
      fluid
      autoFocus={autoFocus}
      icon={icon}
      iconPosition={iconPosition}
      size={size}
      className={clsx('aridhia-role-field-input aridhia-is-edit-mode primary', className)}
      value={text || ''}
      maxLength={maxLength}
      placeholder={intl.formatMessage({ id: `cohort.${type}.placeholder` })}
      onChange={(e, { value }) => { onChange(value); }}
    />
  );
};

export default CohortFieldInput;
